import { render, staticRenderFns } from "./DeleteContactContainer.vue?vue&type=template&id=b82d849e&"
import script from "./DeleteContactContainer.vue?vue&type=script&lang=js&"
export * from "./DeleteContactContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports